import React, { useState, useEffect, useRef } from 'react';
import '../../styles/Testimonials.css';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const intervalRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      name: 'Rahul Sharma',
      location: 'Mumbai, India',
      rating: 5,
      text: 'Amazing experience at AA GRAND HOTEL! The rooms were luxurious, staff was incredibly friendly, and the location is perfect. Couple friendly and very private. Highly recommend!',
      image: 'https://ui-avatars.com/api/?name=Rahul+Sharma&background=FFD700&color=1a0a0a&size=60'
    },
    {
      id: 2,
      name: 'Priya Patel',
      location: 'Delhi, India',
      rating: 5,
      text: 'Best couple-friendly hotel in Hyderabad! The 4-hour stay package was perfect for us. Clean rooms, great service, and very affordable. Will definitely visit again!',
      image: 'https://ui-avatars.com/api/?name=Priya+Patel&background=FFD700&color=1a0a0a&size=60'
    },
    {
      id: 3,
      name: 'Amit Singh',
      location: 'Bangalore, India',
      rating: 5,
      text: 'Excellent hotel for short stays. The cab service made our city tour very convenient. Staff is very cooperative and the rooms are spotless. Value for money!',
      image: 'https://ui-avatars.com/api/?name=Amit+Singh&background=FFD700&color=1a0a0a&size=60'
    },
    {
      id: 4,
      name: 'Sneha Reddy',
      location: 'Hyderabad, India',
      rating: 5,
      text: 'AA GRAND HOTEL is our go-to place for quick getaways. Love the couple-friendly atmosphere, 24/7 service, and the delicious food. A hidden gem in Hyderabad!',
      image: 'https://ui-avatars.com/api/?name=Sneha+Reddy&background=FFD700&color=1a0a0a&size=60'
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    if (isAutoPlaying) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
      }, 5000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isAutoPlaying, testimonials.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
    // Reset auto-play after user interaction
    setTimeout(() => {
      setIsAutoPlaying(true);
    }, 8000);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
    setIsAutoPlaying(false);
    setTimeout(() => {
      setIsAutoPlaying(true);
    }, 8000);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
    setIsAutoPlaying(false);
    setTimeout(() => {
      setIsAutoPlaying(true);
    }, 8000);
  };

  const renderStars = (rating) => {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="testimonials-container">
        {/* Section Header */}
        <div className="testimonials-header">
          <span className="testimonials-badge">✦ Guest Reviews</span>
          <h2 className="testimonials-title">
            What Our <span className="highlight">Guests Say</span>
          </h2>
          <p className="testimonials-subtitle">
            Real experiences from our happy guests
          </p>
        </div>

        {/* Testimonials Slider */}
        <div className="testimonials-slider">
          <div 
            className="testimonials-track"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {testimonials.map((testimonial) => (
              <div className="testimonial-card" key={testimonial.id}>
                <div className="testimonial-content">
                  <div className="testimonial-stars">
                    {renderStars(testimonial.rating)}
                  </div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  
                  <div className="testimonial-author">
                    <img 
                      src={testimonial.image} 
                      alt={testimonial.name}
                      className="testimonial-avatar"
                    />
                    <div className="testimonial-info">
                      <h4>{testimonial.name}</h4>
                      <span>{testimonial.location}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Slider Controls */}
          <button 
            className="testimonial-arrow prev"
            onClick={prevSlide}
            aria-label="Previous review"
          >
            ‹
          </button>
          <button 
            className="testimonial-arrow next"
            onClick={nextSlide}
            aria-label="Next review"
          >
            ›
          </button>
        </div>

        {/* Dots */}
        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to review ${index + 1}`}
            />
          ))}
        </div>

        {/* Rating Summary */}
        <div className="testimonials-summary">
          <div className="summary-item">
            <span className="summary-number">4.8</span>
            <span className="summary-label">Average Rating</span>
            <div className="summary-stars">★★★★★</div>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-item">
            <span className="summary-number">500+</span>
            <span className="summary-label">Happy Guests</span>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-item">
            <span className="summary-number">100%</span>
            <span className="summary-label">Couple Friendly</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;